import {
	ETableStructureAlign,
	ETableStructureType,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { TPpwrManualReportingCountry } from 'redux/reducers/ppwr/types';
import { EIconButtons } from 'services/constants/iconsTypes';

export const PPWR_MANUAL_REPORT_ACTIONS = {
	EDIT: 'Edit',
};

export const tableStructure: TTableStructure<keyof TPpwrManualReportingCountry>[] = [
	{
		name: 'Country',
		selector: 'countryCode',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.COUNTRY_CODE_EU,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Country Code',
		selector: 'countryCode',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Parcels Count',
		selector: 'parcelsCount',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: '',
		selector: 'actions' as keyof TPpwrManualReportingCountry,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		buttons: [{ name: PPWR_MANUAL_REPORT_ACTIONS.EDIT, icon: EIconButtons.EDIT, tooltip: 'Edit' }],
	},
];
